module.exports = __webpack_public_path__ + "img/cc1-social-ecological-transformation.d0c51fed.png";